module.exports = __webpack_public_path__ + "marker-icon.2273e3d8ad9264b7daa5.png";